import React from 'react';
// import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

class SignIn extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleLoginInput = this.handleLoginInput.bind(this);
    this.login = this.login.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
  }

  componentWillMount() {
    this.state = {
      username: null,
      password: null,
      forgotPassword: false,
      resetSent: false
    }
  }

  handleLoginInput() {
    this.setState({
      username: this.username.value,
      password: this.password.value
    })
  }

  login() {
    this.props.store.SessionStore.login(this.state.username, this.state.password, this.handleLogin);
  }

  handleLogin() {
    this.props.routing.history.push('/');
  }

  forgotPassword(e) {
    e.preventDefault();

    this.setState({
      forgotPassword: !this.state.forgotPassword
    });
  }

  resetPassword() {
    const { SettingsStore } = this.props.store;

    const callback = () => {
      this.setState({
        resetSent: true
      });
    }

    SettingsStore.resetPassword(this.email.value, callback);
  }

  render() {
    const { translation } = this.props;

    if(!this.state.forgotPassword) {
      return(
        <div className="pane__content">
          <h1 className="pane__title">
            {translation.heading}
          </h1>

          <form
            onSubmit={(e) => this.props.checkValidity(e, this.login)}
            noValidate
          >
            <fieldset>
              <ul className="fields">
                <li>
                  <label
                    className="meta"
                    htmlFor="signup-email"
                  >
                    {translation.email}
                  </label>

                  <input
                    type="email"
                    id="signup-email"
                    placeholder={translation.email}
                    required
                    aria-required="true"
                    onChange={this.handleLoginInput}
                    ref={(input) => this.username = input}
                  />
                </li>
                <li>
                  <label
                    className="meta"
                    htmlFor="signup-password"
                  >
                    {translation.password}
                  </label>

                  <input
                    type="password"
                    id="signup-password"
                    placeholder={translation.password}
                    required
                    aria-required="true"
                    onChange={this.handleLoginInput}
                    ref={(input) => this.password = input}
                  />
                </li>
              </ul>
            </fieldset>

            <button
              className="btn--link"
              type="button"
              onClick={(e) => this.forgotPassword(e)}
            >
              {translation.forgot_password}
            </button>

            <button
              className="btn"
              type="submit"
            >
              {translation.sign_in}
            </button>
          </form>

          {/* <span>{translation.no_account} <Link to="/account/sign-up">{translation.sign_up}</Link>.</span> */}
        </div>
      )
    } else if(this.state.forgotPassword && !this.state.resetSent) {
      return(
        <div className="pane__content">
          <h1 className="pane__title">
            {translation.forgot_password}
          </h1>

          <form
            onSubmit={(e) => this.props.checkValidity(e, this.resetPassword)}
            noValidate
          >
            <fieldset>
              <ul className="fields">
                <li>
                  <label
                    className="meta"
                    htmlFor="forgot-email"
                  >
                    {translation.email}
                  </label>

                  <input
                    type="email"
                    id="forgot-email"
                    placeholder={translation.email}
                    required
                    aria-required="true"
                    ref={(input) => this.email = input}
                  />
                </li>
              </ul>
            </fieldset>

            <button
              className="btn--link"
              type="button"
              onClick={(e) => this.forgotPassword(e)}
            >
              {translation.cancel}
            </button>

            <button
              className="btn"
              type="submit"
            >
              {translation.reset}
            </button>
          </form>
        </div>
      )
    } else if(this.state.forgotPassword && this.state.resetSent) {
      return (
        <div className="pane__content">
          <h1 className="pane__title">
            {translation.reset_heading}
          </h1>

          <p>{translation.reset_body}</p>
        </div>
      )
    }

    return null;
  }
}

export default translate('SignIn')(SignIn);



// WEBPACK FOOTER //
// ./src/app/components/Account/SignIn.js